import { isEmpty } from 'lodash'

type TypeListProps = {
  value?: string[]
  list_tag?: 'ol' | 'ul'
}

const TypeList = ({ list_tag, value }: TypeListProps) => {
  if (isEmpty(value)) return '-'

  const ListTag = list_tag ?? 'ul'

  return (
    <ListTag style={{ listStylePosition: 'inside', margin: 0, padding: 4 }}>
      {value?.map((item, index) => (
        <li key={`${index}-${item}`}>{item}</li>
      ))}
    </ListTag>
  )
}

export { TypeList }
